import { attr, belongsTo } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const Dproject = ApplicationRecord.extend({
  static: {
    jsonapiType: 'dprojects',
  },
  attrs: {
    assignedTo: attr(),
    assignedBy: attr(),
    status: attr(),
    projectType: attr(),
    invoiceStatus: attr(),
    createdAt: attr(),
    priority: attr(),
    schoolName: attr(),
    schoolRoute: attr(),
    districtName: attr(),
    exported: attr(),
    schoolId: attr(),
    school: belongsTo(),
    district: belongsTo(),
  },
});

export default Dproject;
